module.exports = __webpack_public_path__ + "static/img/0102_01.1ed46e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/01/0102_01.png
// module id = TG3m
// module chunks = 1